import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { useI18n } from "@/context/I18nContext";
import api from "@/lib/api";

export default function BlogDetail() {
  const { slug } = useParams();
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  const [post, setPost] = useState(undefined);
  useEffect(() => {
    api.get(`/content/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setPost(null));
  }, [slug]);

  usePageMeta(post?.title || L("Articolo", "Article", "Artikel"), post?.excerpt);

  if (post === undefined) return <div className="py-32 text-center text-slate-500">{L("Caricamento…", "Loading…", "Wird geladen…")}</div>;
  if (post === null) return (
    <div className="py-32 text-center">
      <p className="text-slate-400">{L("Articolo non trovato.", "Article not found.", "Artikel nicht gefunden.")}</p>
      <Link to="/blog" className="text-cyanx mt-4 inline-block">← {L("Torna al blog", "Back to blog", "Zurück zum Blog")}</Link>
    </div>
  );

  return (
    <div>
      <PageHero eyebrow={post.category} title={post.title} subtitle={post.excerpt} />
      <article className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="prose prose-invert max-w-none text-slate-300 leading-relaxed whitespace-pre-line">{post.body}</div>
        <Link to="/blog" className="mt-10 inline-block text-cyanx hover:text-white">← {L("Torna al blog", "Back to blog", "Zurück zum Blog")}</Link>
      </article>
    </div>
  );
}
